/**
 * 解析所有模块下路由装配到主路由中
 * @type {Null}
 */
import { Log } from '$utils'
const context = require.context('@src/modules', true, /router\.js$/)
let modulesRouters = {
  dependApp: [],
  dependHome: [],
}
context.keys().forEach((key) => {
  const routerKey = key.split('/')
  const isRouter = routerKey[routerKey.length - 1] === 'router.js'
  if (isRouter) {
    const router = context(key).default
    if (router && router.length) {
      router.forEach((item) => {
        if (item.meta && item.meta.dependApp) {
          modulesRouters.dependApp.push(item)
        } else {
          modulesRouters.dependHome.push(item)
        }
      })
    }
  }
})
Log.debug('路由设置==>', modulesRouters.dependHome.map((r) => r.name).join(', '))
export default modulesRouters
